export const LOGIN_REQUEST                 = 'LOGIN/REQUEST';
export const LOGIN_SUCCESS                 = 'LOGIN/SUCCESS';
export const LOGIN_FAILURE                 = 'LOGIN/FAILURE';


export const ACTION_REQUEST              = 'ACTIVATE/REQUEST';
export const ACTION_SUCCESS              = 'ACTIVATE/SUCCESS';
export const ACTION_FAILURE              = 'ACTIVATE/FAILURE';



// WEBPACK FOOTER //
// ./assets/app/login/constants/login.js